<div class="modal-header">
  <h3 class="modal-title">
    Nachfertigung {{reproduction.id}}-{{reproduction.index}}
    wird mit BA {{reproduction.original_id}}-{{reproduction.original_index}}
    zusammengefügt
  </h3>
  <div>
    Diese Aktion kann nicht rückgängig gemacht werden.
  </div>
</div>

<form class="form-horizontal" [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-body">
    <div class="form-group">
      <label class="col-md-2 control-label" for="note">Bemerkung:</label>

      <div class="col-md-10">
        <textarea id="note" class="form-control" formControlName="note" rows="5"></textarea>
      </div>
    </div>

    @if (!!errorType) {
      <div class="red_alert">
        Es ist ein Fehler aufgetreten:
        @switch (errorType) {
          @case ('ba.source.wrong.step') {
            <div>
              Der Zusammenfügungspunkt wurde noch nicht erreicht.
            </div>
          }
          @case ('ba.reproduction.no.mergepoint') {
            <div>
              Die Nachfertigung hat keinen Zusammenfügungspunkt.
            </div>
          }
          @case ('ba.source.closed') {
            <div>
              Diese Nachfertigung wurde bereits zusammengefügt, storniert oder gelöscht.
            </div>
          }
          @case ('ba.source.not.found') {
            <div>
              Konnte Nachfertigung nicht finden.
            </div>
          }
          @case ('ba.target.not.found') {
            <div>
              Konnte den Hauptbetriebsauftrag nicht finden.
            </div>
          }
          @case ('ba.target.closed') {
            <div>
              Der Hauptbetriebsauftrag wurde storniert oder gelöscht.
            </div>
          }
          @case ('ba.reproduction.has.dependencies') {
            <div>
              Es gibt noch Nachfertigungen für diesen Betriebsauftrag.
              Bitte fügen Sie diese zuerst zu diesem hinzu.
            </div>
          }
        }
      </div>
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-default pull-left" (click)="dismiss()" type="button">
      Abbrechen
    </button>
    <button class="btn btn-success pull-right" type="submit" [disabled]="!form.valid">
      Nachfertigung mit Haupt BA zusammenfügen
    </button>
  </div>
</form>
